<template>
  <div class="container">
    <div class="box-container">
      <div v-for="n in 40" :key="n" class="box"></div>
    </div>

    <div class="content-container">
      <el-row>
        <el-col :span="8">
          <div class="selfie pt-3 row justify-content-start">
            <div class="col-3">
              <img
                class="img-fluid"
                src="../../assets/me.jpg"
                alt="Xster_Selfie"
                style="width: 300px"
              />
            </div>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="col">
            <h2>Get in touch!</h2>
            <h5>Email: (5-1)959(5-1)9(5-1)30@企鹅.com</h5>
            <h5>WeChat:</h5>
            <img style="width: 220px" src="../../assets/v_card.jpeg" alt="WeChat" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";
// import { Flip } from "gsap/Flip";

gsap.registerPlugin(TextPlugin);
export default {
  name: "ContactPage",
  mounted() {
    gsap.fromTo(".selfie", { x: 200 }, { x: 0, duration: 1, ease: "bounce.out" });

    // gsap.fromTo(this.$el, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1 });
    // gsap.fromTo(
    //   this.$el.querySelector("img"),
    //   { opacity: 0 },
    //   { opacity: 1, duration: 1, delay: 0.5 }
    // );
    // gsap.fromTo(
    //   this.$el.querySelector("h2"),
    //   { opacity: 0, y: -20 },
    //   { opacity: 1, y: 0, duration: 1, delay: 0.5 }
    // );

    // gsap.fromTo(".box", { x: 200 }, { x: 0, duration: 1, ease: "bounce.out" });

    this.animateBoxes("random", null, "power3.inOut");
  },
  methods: {
    animateBoxes(from, axis, ease) {
      var grid = [2, 20]; //[rows, columns]
      let tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 });
      //one stagger call does all the animation:
      tl.to(".box", {
        duration: 1.5,
        scale: 0.05,
        y: 0,
        yoyo: true,
        repeat: 1,
        ease: ease,
        stagger: {
          amount: 1.5,
          grid: grid,
          axis: axis,
          ease: ease,
          from: from,
        },
      });
    },
  },
};
</script>

<style scoped>
.box-container {
  position: absolute;
  display: grid;
  grid-template-columns: repeat(20, 1fr);
  /* gap: 5px; */
  margin-bottom: 20px;
}
.box {
  display: inline-block;
  width: 5vw;
  height: 5vw;
  background-color: #1c4935;
  /* position: absolute;
  top: 0;
  left: 0;
  z-index: 10; */
}

.container {
  position: relative;
  background: rgba(0, 68, 170, 0.3);
  overflow: scroll;
  height: 80vh;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
}

.container::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

.content-container {
  position: relative;
  z-index: 5;
}
</style>
